export default __webpack_public_path__ + "static/media/myjourney-bluetree-fruitnutflower.8bdc4f4b.svg";